import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

export const VisitorBreakdownWidget = ({ data, loading }) => {
  const newV = data?.new_visitors || 0;
  const returningV = data?.returning_visitors || 0;
  const total = newV + returningV;
  const rows = [
    { name: "New", value: newV, color: "#3B82F6" },
    { name: "Returning", value: returningV, color: "#8B5CF6" },
  ];

  return (
    <div data-testid="visitor-breakdown-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>New vs Returning</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : total === 0 ? (
        <p className="text-sm text-slate-500">No visitor data yet.</p>
      ) : (
        <div className="flex items-center gap-6">
          <div style={{ width: 140, height: 140 }}>
            <ResponsiveContainer minWidth={100} minHeight={100}>
              <PieChart>
                <Pie data={rows} dataKey="value" nameKey="name" innerRadius={40} outerRadius={65} paddingAngle={4}>
                  {rows.map((r) => <Cell key={r.name} fill={r.color} />)}
                </Pie>
                <Tooltip contentStyle={{ background: "#0F172A", border: "1px solid #334155" }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="space-y-2">
            {rows.map((r) => (
              <div key={r.name} className="flex items-center gap-2 text-sm">
                <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: r.color }} />
                <span className="text-slate-300">{r.name}</span>
                <span className="text-slate-500 font-mono">{r.value} ({total ? Math.round((r.value / total) * 100) : 0}%)</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
